import { apolloClient as client } from 'src/graphql/client/apollo-client';
import { EscrowMembersDocument } from 'src/graphql/actions/escrowMembers/escrowMembers.query';
import { UsersDocument } from 'src/graphql/actions/user/users.query';

export const refetchEscrowMembers = () => {
  client.cache.evict({ fieldName: 'escrowMembers' });
  client.cache.gc();
  client.refetchQueries({
    include: [EscrowMembersDocument],
  });
};

export const refetchUsers = () => {
  client.cache.evict({ fieldName: 'users' });
  client.cache.gc();
  client.refetchQueries({
    include: [UsersDocument],
  });
};
